/**
 * 登录逻辑
 * 因为app下需要使用app提供的登录功能才能将登录状态同步到app，所以单独拿出来处理
 */
import { is58App, isHaojieApp, mLoginPath, mobileBindPath } from './Helper';

const WBAPP = window.WBAPP || {};


window.bindMobileCallBack = function (type) {
    if (`${type}` === '0') { // 返回0绑定成功
        window.location.reload();
    } else {
        window.WBAPP.action.goback();
    }
};

const appLoginSuccessCallBack = function (state) {
    if (String(state) !== '0') {
        window.WBAPP.action.goback();
    } else {
        window.location.reload();
    }
};


export function gotoLogin() {
    // 如果是在58app 并且版本是7.5.0以上 就使用58的登录
    if (is58App() || isHaojieApp()) {
        try {
            const appVersion = WBAPP.common.appVersion;
            if (WBAPP.util.compareVersion(appVersion, '7.5.0') > 0) {
                WBAPP.invoke('login_mobile_dynamic', appLoginSuccessCallBack);
            } else {
                window.location.replace(mLoginPath());
            }
        } catch (e) {
            window.location.replace(mLoginPath());
        }
    } else {
        window.location.replace(mLoginPath());
    }
}

export function gotoBindMobile() {
    // 如果是在58app 则使用58app的绑定手机号
    if (is58App() || isHaojieApp()) {
        try {
            WBAPP.invoke('bind_account', { type: 'PHONE' }, window.bindMobileCallBack);
        } catch (e) {
            window.location.replace(mobileBindPath());
        }
    } else {
        window.location.replace(mobileBindPath());
    }
}




// WEBPACK FOOTER //
// ./src/api/Login.js